<div class="paginator">
  <ng-container *ngIf="type === 'default'; else customPaginator">
    <div class="col-md-4 col-12">
      <div class="pageSize">
        <p class="pageSizeText">Registros por página (Total: {{count}})</p>
        <ngb-pagination (pageChange)="sizePageChange($event)" [directionLinks]="false" [collectionSize]="40"
          [(page)]="currentSizePage" [maxSize]="10">
          <ng-template ngbPaginationNumber let-p>{{ getPageLabel(p) }}</ng-template>
        </ngb-pagination>
      </div>
    </div>
    <div class="col-md-8 col-12">
      <div class="collectionSize">
        <p class="collectionSizeText">Escolher página:</p>
        <ngb-pagination [(page)]="page" [maxSize]="5" [boundaryLinks]="true" [pageSize]="pageSize"
          [collectionSize]="maxPage()" (pageChange)="pageChange()">
        </ngb-pagination>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #customPaginator>
  <div class="flex align-items-center custom-pagination" [ngClass]="{ 'justify-content-between': displayPageSize, 'justify-content-center': !displayPageSize }">
    <ng-container *ngIf="displayPageSize">
      <div class="records d-flex align-items-center gap-2">
        <ng-container *ngIf="showDisplayedCount; else defaultPageSizeLabel">
          Mostrando {{ showingCount }} de {{ count }} linhas
        </ng-container>
        <ng-template #defaultPageSizeLabel>
          Mostrando
        </ng-template>
        <select
          class="form-control form-control-sm w-auto"
          [(ngModel)]="perPage"
          (change)="handleCustomSizePageChanged()"
          [attr.aria-label]="'Linhas por página'"
        >
          <option *ngFor="let size of optionSize" [value]="size">{{ size }}</option>
        </select>
        <ng-container *ngIf="!showDisplayedCount">
          de {{ count }} linhas
        </ng-container>
      </div>
    </ng-container>
    <div class="links d-flex align-items-center">
      <ngb-pagination [(page)]="page" [maxSize]="5" [boundaryLinks]="true" [pageSize]="pageSize"
        [collectionSize]="maxPage()" (pageChange)="pageChange()"></ngb-pagination>
    </div>
  </div>
</ng-template>